<template>
    <div class="enemy-data row">
        <div class="col-xl-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">目標</span>
                </div>
                <select class="form-control" v-model="target" v-on:change="target_change">
                    <option v-for="(e, index) in enemyList" v-bind:value="index" v-bind:key="index">
                        {{ e.text }}
                    </option>
                </select>
                <select class="form-control" v-model="type" v-if="enemyList[target]['stat'].length>1" v-on:change="type_change">
                    <option v-for="(e, index) in enemyList[target]['stat']" v-bind:value="index" v-bind:key="index">
                        {{ e.text }}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-xl-6">
            <div class="input-group">
                <div class="input-group-prepend ">
                    <span class="input-group-text">耐久</span>
                </div>
                <input type="number" class="form-control" disabled v-bind:value="hp">
                <div class="input-group-prepend">
                    <span class="input-group-text">裝甲</span>
                </div>
                <input type="number" class="form-control" disabled v-bind:value="armor">
            </div>
        </div>
        <div class="col-xl-12" v-if="enemyList[target].effect.text!=undefined">
            {{ enemyList[target].effect.text }}
        </div>
    </div>
</template>

<script>
let effects = {
    "artillery": {
        36:{"precap":[1.85]},
        126:{"precap":[1.6, 1.7, 1, 1, 1, 1]},
        348:{"precap":[1.5, 1.8, 1, 1, 1, 1]},
        346:{"precap":[1.3, 1.5, 1, 1, 1, 1]},
        10008:{"precap":[1.5]},
        10011:{"precap":[1.5, 2, 1, 1, 1, 1]},
        167:{"precap":[2.4, 1, 1, 1, 1, 1]},
        "A":{"precap":[1.8]},
        "B":{"precap":[1.15]},
        "C":{"precap":[1.5]},
        "DD":{"precap":[1.4]},
        "E":{"precap":[1.5]},
        "FF":{"precap":[1.4]},
        "G":{"precap":[1.3]},
        "HH":{"precap":[1.2]},
        "I":{"precap":[2]},
        "KK":{"precap":[1.35]},
        "a12":[1.4,1.4,1,1,1,1,1,1,1,1],
        "b12":[0,0,30,0,0,0,0,0,0,0],
        "land_craft_imp":{"precap":true},
        "type_2_imp":{"precap":true},
    },
    "hard": {
        35:{"precap":[1.75]},
        126:{"precap":[1.4, 1.5, 1, 1, 1, 1]},
        348:{"precap":[1.3, 1.65, 1, 1, 1, 1]},
        346:{"precap":[1.2, 1.4, 1, 1, 1, 1]},
        10011:{"precap":[1.4, 1.75, 1, 1, 1, 1]},
        167:{"precap":[2.4, 1, 1, 1, 1, 1]},
        "A":{"precap":[1.8]},
        "B":{"precap":[1.15]},
        "C":{"precap":[1.2]},
        "DD":{"precap":[1.4]},
        "E":{"precap":[1.2]},
        "FF":{"precap":[1.4]},
        "G":{"precap":[1.3]},
        "HH":{"precap":[1.1]},
        "I":{"precap":[1.8]},
        "KK":{"precap":[1.35]},
        "a12":[1,1,1,1,1,1,1,1,1,1],
        "b12":[0,0,30,0,0,0,0,0,0,0],
        "land_craft_imp":{"precap":true},
        "type_2_imp":{"precap":true},
    },
    "harbourSummer": {
        35:{"precap":[1.75]},
        36:{"precap":[1.3]},
        126:{"precap":[1.4, 1.2, 1, 1, 1, 1]},
        348:{"precap":[1.25, 1.4, 1, 1, 1, 1]},
        346:{"precap":[1.1, 1.15, 1, 1, 1, 1]},
        10008:{"precap":[1.3]},
        10011:{"precap":[1.3, 1.2, 1, 1, 1, 1]},
        167:{"precap":[2.8, 1, 1, 1, 1, 1]},
        "A":{"precap":[1.7]},
        "B":{"precap":[1.2]},
        "C":{"precap":[1.6]},
        "DD":{"precap":[1.5]},
        "E":{"precap":[1.6]},
        "FF":{"precap":[1.5]},
        "G":{"precap":[1.5]},
        "HH":{"precap":[1.1]},
        "I":{"precap":[2]},
        "KK":{"precap":[1.5]},
        "a12":[1.4,1.4,1,1,1,1,1,1,1,1],
        "b12":[0,0,30,0,0,0,0,0,0,0],
        "land_craft_imp":{"precap":true},
        "type_2_imp":{"precap":true},
    },
    "soft": {
        35:{"precap":[2.5]},
        126:{"precap":[1.3, 1.4, 1, 1, 1, 1]},
        348:{"precap":[1.25, 1.5, 1, 1, 1, 1]},
        346:{"precap":[1.2, 1.3, 1, 1, 1, 1]},
        10008:{"precap":[1.2]},
        167:{"precap":[1.5, 1, 1, 1, 1, 1]},
        "A":{"precap":[1.4]},
        "B":{"precap":[1.15]},
        "C":{"precap":[1.5]},
        "DD":{"precap":[1.3]},
        "E":{"precap":[1.5]},
        "FF":{"precap":[1.3]},
        "G":{"precap":[1.1]},
        "HH":{"precap":[1.1]},
        "I":{"precap":[1.1]},
        "KK":{"precap":[1.2]},
        "a12":[1,1,1,1,1,1,1,1,1,1],
        "b12":[0,0,30,0,0,0,0,0,0,0],
        "rikugun":{"precap":[1.4, 1.2, 1.1]},
        "land_craft_imp":{"precap":true},
        "type_2_imp":{"precap":true},
    },
    "supply": {
        35:{"precap":[2.5]},
        126:{"precap":[1.3, 1.4, 1, 1, 1, 1], "postcap":[1.25, 1.3, 1, 1, 1, 1]},
        348:{"precap":[1.25, 1.5, 1, 1, 1, 1], "postcap":[1.2, 1.4, 1, 1, 1, 1]},
        346:{"precap":[1.2, 1.3, 1, 1, 1, 1], "postcap":[1.15, 1.2, 1, 1, 1, 1]},
        10008:{"precap":[1.2]},
        167:{"precap":[1.5, 1, 1, 1, 1, 1], "postcap":[1.7, 1, 1, 1, 1, 1]},
        "A":{"precap":[1.4], "postcap":[1.7]},
        "B":{"precap":[1.15], "postcap":[1.2]},
        "C":{"precap":[1.5], "postcap":[1.3]},
        "DD":{"precap":[1.3], "postcap":[1.6]},
        "E":{"precap":[1.5], "postcap":[1.3]},
        "FF":{"precap":[1.3], "postcap":[1.6]},
        "G":{"precap":[1.1], "postcap":[1.5]},
        "HH":{"precap":[1.1], "postcap":[1.1]},
        "I":{"precap":[1.1], "postcap":[1.2]},
        "KK":{"precap":[1.2], "postcap":[1.5]},
        "a12":[1,1,1,1,1,1,1,1,1,1],
        "b12":[0,0,30,0,0,0,0,0,0,0],
        "rikugun":{"precap":[1.4, 1.2, 1.1], "postcap":[1.85, 1.45, 1.2]},
        "land_craft_imp":{"precap":true, "postcap":true},
        "type_2_imp":{"precap":true, "postcap":true},
        "other":{"postcap":[0]}
    },
    "supply3V": {
        126:{"postcap":[1.25, 1.3, 1, 1, 1, 1]},
        348:{"postcap":[1.2, 1.4, 1, 1, 1, 1]},
        346:{"postcap":[1.15, 1.2, 1, 1, 1, 1]},
        167:{"postcap":[1.7, 1, 1, 1, 1, 1]},
        "A":{"postcap":[1.7]},
        "B":{"postcap":[1.2]},
        "C":{"postcap":[1.3]},
        "DD":{"postcap":[1.6]},
        "E":{"postcap":[1.3]},
        "FF":{"postcap":[1.6]},
        "G":{"postcap":[1.5]},
        "HH":{"postcap":[1.1]},
        "I":{"postcap":[1.2]},
        "KK":{"postcap":[1.5]},
        "a12":[1,1,1,1,1,1,1,1,1,1],
        "b12":[0,0,30,0,0,0,0,0,0,0],
        "rikugun":{"postcap":[1.85, 1.45, 1.2]},
        "land_craft_imp":{"postcap":true},
        "type_2_imp":{"postcap":true},
        "other":{"postcap":[0]}
    },
    "anchorWDV": {
        35:{"precap":[1.45]},
        126:{"postcap":[1.2, 1.3, 1, 1, 1, 1]},
        348:{"postcap":[1.1, 1.4, 1, 1, 1, 1]},
        346:{"postcap":[1.1, 1, 1, 1, 1, 1]},
        10011:{"postcap":[1.4, 1.75, 1, 1, 1, 1]},
        167:{"postcap":[2.4, 1, 1, 1, 1, 1]},
        "A":{"postcap":[1.4]},
        "B":{"postcap":[1.15]},
        "C":{"postcap":[1.2]},
        "DD":{"postcap":[1.4]},
        "E":{"postcap":[1.2]},
        "FF":{"postcap":[1.4]},
        "G":{"postcap":[1.2]},
        "HH":{"postcap":[1.1]},
        "I":{"postcap":[1.8]},
        "KK":{"precap":[1.35]},
        "a12":[1,1,1,1,1,1,1,1,1,1],
        "b12":[0,0,0,0,0,0,0,0,0,0],
        "land_craft_imp":{"postcap":true},
        "type_2_imp":{"postcap":true},
        "text": "第二個迫擊炮倍率不明"
    },
    "dock": {
        35:{"precap":[1.3]},
        126:{"postcap":[1.1, 1.2, 1, 1, 1, 1]},
        348:{"postcap":[1.2, 1.4, 1, 1, 1, 1]},
        346:{"postcap":[1.15, 1.2, 1, 1, 1, 1]},
        10008:{"postcap":[1.1]},
        10011:{"postcap":[1.1, 1.1, 1, 1, 1, 1]},
        167:{"postcap":[1.2, 1, 1, 1, 1, 1]},
        "A":{"postcap":[1.1]},
        "B":{"postcap":[1.1]},
        "C":{"postcap":[1.15]},
        "DD":{"postcap":[1.15]},
        "E":{"postcap":[1.15]},
        "FF":{"postcap":[1.15]},
        "G":{"postcap":[1.1]},
        "I":{"postcap":[1]},
        "J":{"postcap":[1.4]},
        "KK":{"precap":[1.2]},
        "a12":[1,1,1,1,1,1,1,1,1,1],
        "b12":[0,0,0,0,0,0,0,0,0,0],
        "land_craft_imp":{"postcap":true},
        "type_2_imp":{"postcap":true},
        "text": "對地噴進炮、迫擊炮、特大發、第二台武大/AB倍率不明"
    }
}
export default {
    data() {
        return {
            counter: this.initialCounter,
            target: 0,
            type: 0,
            enemyList: [
                {
                    "text":"集積地棲姫",
                    "stat":[
                        {"text":"I", "hp":600, "armor":100},
                        {"text":"II", "hp":600, "armor":130},
                        {"text":"III", "hp":600, "armor":160},
                        {"text":"壞I", "hp":380, "armor":130},
                        {"text":"壞II", "hp":430, "armor":160},
                        {"text":"壞III", "hp":480, "armor":190}
                    ],
                    "effect": effects['supply']
                },
                {
                    "text":"集積地棲姫 II",
                    "stat":[
                        {"text":"I", "hp":600, "armor":50},
                        {"text":"II", "hp":660, "armor":130},
                        {"text":"III", "hp":990, "armor":180},
                        {"text":"壞I", "hp":600, "armor":80},
                        {"text":"壞II", "hp":660, "armor":170},
                        {"text":"壞III", "hp":990, "armor":240}
                    ],
                    "effect": effects['supply']
                },
                {
                    "text":"集積地棲姫 III",
                    "stat":[
                        {"text":"I", "hp":900, "armor":16},
                        {"text":"II", "hp":2000, "armor":126},
                        {"text":"III", "hp":6000, "armor":192},
                        {"text":"壞I", "hp":900, "armor":25},
                        {"text":"壞II", "hp":2000, "armor":147},
                        {"text":"壞III", "hp":6000, "armor":225}
                    ],
                    "effect": effects['supply']
                },
                {
                    "text":"集積地棲姫 IV",
                    "stat":[
                        {"text":"I", "hp":1200, "armor":15},
                        {"text":"II", "hp":2400, "armor":92},
                        {"text":"III", "hp":4800, "armor":125},
                        {"text":"IV", "hp":8000, "armor":185},
                        {"text":"壞I", "hp":1200, "armor":26},
                        {"text":"壞II", "hp":2400, "armor":115},
                        {"text":"壞III", "hp":4800, "armor":134},
                        {"text":"壞IV", "hp":8000, "armor":225}
                    ],
                    "effect": effects['supply']
                },
                {
                    "text":"集積地夏姫",
                    "stat":[
                        {"text":"I", "hp":690, "armor":133},
                        {"text":"II", "hp":690, "armor":163}
                    ],
                    "effect": effects['supply']
                },
                {
                    "text":"集積地棲姫 II 夏季上陸mode",
                    "stat":[
                        {"text":"I", "hp":600, "armor":34},
                        {"text":"II", "hp":1200, "armor":124},
                        {"text":"III", "hp":2400, "armor":174},
                        {"text":"壞I", "hp":600, "armor":64},
                        {"text":"壞II", "hp":1200, "armor":164},
                        {"text":"壞III", "hp":2400, "armor":234}
                    ],
                    "effect": effects['supply']
                },
                {
                    "text":"集積地棲姫 II バカンスmode",
                    "stat":[
                        {"text":"I", "hp":440, "armor":26},
                        {"text":"II", "hp":1200, "armor":137},
                        {"text":"III", "hp":3200, "armor":170},
                        {"text":"IV", "hp":4800, "armor":203},
                        {"text":"壞I", "hp":440, "armor":47},
                        {"text":"壞II", "hp":1200, "armor":169},
                        {"text":"壞III", "hp":3200, "armor":202},
                        {"text":"壞IV", "hp":4800, "armor":225}
                    ],
                    "effect": effects['supply']
                },
                {
                    "text":"集積地棲姫 III バカンスmode",
                    "stat":[
                        {"text":"I", "hp":960, "armor":25},
                        {"text":"II", "hp":1800, "armor":165},
                        {"text":"III", "hp":3600, "armor":44},
                        {"text":"IV", "hp":7200, "armor":194},
                        {"text":"壞I", "hp":960, "armor":135},
                        {"text":"壞II", "hp":1800, "armor":195},
                        {"text":"壞III", "hp":3600, "armor":164},
                        {"text":"壞IV", "hp":7200, "armor":224}
                    ],
                    "effect": effects['supply3V'],
                    "enableTorp": true
                },
                {
                    "text":"集積地棲姫 V バカンスmode",
                    "stat":[
                        {"text":"I", "hp":2300, "armor":12},
                        {"text":"II", "hp":5200, "armor":91},
                        {"text":"III", "hp":8600, "armor":191},
                        {"text":"壞I", "hp":2300, "armor":22},
                        {"text":"壞II", "hp":5200, "armor":121},
                        {"text":"壞III", "hp":8600, "armor":231}
                    ],
                    "effect": effects['supply']
                },
                {
                    "text":"集積地棲姫改",
                    "stat":[
                        {"text":"I", "hp":3000, "armor":8},
                        {"text":"II", "hp":5900, "armor":90},
                        {"text":"III", "hp":9800, "armor":208},
                        {"text":"壞I", "hp":3000, "armor":13},
                        {"text":"壞II", "hp":5900, "armor":113},
                        {"text":"壞III", "hp":9800, "armor":248}
                    ],
                    "effect": effects['supply']
                },
                {
                    "text":"飛行場姫",
                    "stat":[
                        {"text":"I", "hp":500, "armor":140},
                        {"text":"II", "hp":500, "armor":160},
                        {"text":"III", "hp":500, "armor":175},
                        {"text":"IV", "hp":500, "armor":190}
                    ],
                    "effect": effects['soft']
                },
                {
                    "text":"飛行場夏姫",
                    "stat":[
                        {"text":"I", "hp":220, "armor":73},
                        {"text":"II", "hp":330, "armor":83},
                        {"text":"III", "hp":440, "armor":93},
                    ],
                    "effect": effects['soft']
                },
                {
                    "text":"飛行場棲姫",
                    "stat":[
                        {"text":"I", "hp":330, "armor":33},
                        {"text":"II", "hp":440, "armor":55},
                        {"text":"III", "hp":550, "armor":77}
                    ],
                    "effect": effects['soft']
                },
                {
                    "text":"太平洋飛行場姫",
                    "stat":[
                        {"text":"I", "hp":300, "armor":47},
                        {"text":"II", "hp":400, "armor":69},
                        {"text":"III", "hp":500, "armor":91},
                    ],
                    "effect": effects['soft']
                },
                {
                    "text":"港灣棲姫",
                    "stat":[
                        {"text":"I  (4-3 4-5)", "hp":380, "armor":135},
                        {"text":"II (4-5 最終)", "hp":490, "armor":183}
                    ],
                    "effect": effects['soft']
                },
                {
                    "text":"港灣水鬼",
                    "stat":[
                        {"text":"I", "hp":450, "armor":135},
                        {"text":"II", "hp":450, "armor":140},
                        {"text":"III", "hp":500, "armor":140},
                        {"text":"IV", "hp":500, "armor":160}
                    ],
                    "effect": effects['soft']
                },
                {
                    "text":"港灣夏姫",
                    "stat":[
                        {"text":"I", "hp":500, "armor":34},
                        {"text":"II", "hp":600, "armor":124},
                        {"text":"III", "hp":700, "armor":174},
                        {"text":"壞I", "hp":444, "armor":164},
                        {"text":"壞II", "hp":544, "armor":184},
                        {"text":"壞III", "hp":644, "armor":214}
                    ],
                    "effect": effects['harbourSummer']
                },
                {
                    "text":"港灣夏姫 II",
                    "stat":[
                        {"text":"I", "hp":750, "armor":14},
                        {"text":"II", "hp":1050, "armor":186},
                        {"text":"III", "hp":1550, "armor":226},
                        {"text":"壞I", "hp":750, "armor":18},
                        {"text":"壞II", "hp":1050, "armor":216},
                        {"text":"壞III", "hp":1550, "armor":246}
                    ],
                    "effect": effects['harbourSummer']
                },
                {
                    "text":"港湾棲姫 休日mode",
                    "stat":[
                        {"text":"I", "hp":570, "armor":16},
                        {"text":"II", "hp":1700, "armor":126},
                        {"text":"壞I", "hp":570, "armor":23},
                        {"text":"壞II", "hp":1700, "armor":256}
                    ],
                    "effect": effects['harbourSummer']
                },
                {
                    "text":"離島棲鬼",
                    "stat":[
                        {"text":"I", "hp":450, "armor":150},
                        {"text":"II", "hp":450, "armor":155},
                        {"text":"III", "hp":450, "armor":170},
                        {"text":"IV", "hp":450, "armor":185}
                    ],
                    "effect": effects['hard']
                },
                {
                    "text":"離島棲姫",
                    "stat":[
                        {"text":"I (6-4)", "hp":480, "armor":194}
                    ],
                    "effect": effects['hard']
                },
                {
                    "text":"北方棲姫",
                    "stat":[
                        {"text":"I", "hp":360, "armor":135},
                        {"text":"II", "hp":500, "armor":145},
                        {"text":"III (3-5)", "hp":300, "armor":125},
                        {"text":"IV  (3-5 最終)", "hp":390, "armor":140},
                        {"text":"V   (3-5 弱)", "hp":300, "armor":110},
                        {"text":"VI  (3-5 弱 最終)", "hp":390, "armor":125}
                    ],
                    "effect": effects['soft']
                },
                {
                    "text":"リコリス棲姫",
                    "stat":[
                        {"text":"I", "hp":600, "armor":100},
                        {"text":"II", "hp":640, "armor":120},
                        {"text":"III", "hp":680, "armor":140}
                    ],
                    "effect": effects['soft']
                },
                {
                    "text":"泊地水鬼 バカンスmode",
                    "stat":[
                        {"text":"I", "hp":490, "armor":200},
                        {"text":"II", "hp":490, "armor":230},
                        {"text":"III", "hp":490, "armor":270},
                        {"text":"壊I", "hp":490, "armor":220},
                        {"text":"壊II", "hp":490, "armor":250},
                        {"text":"壊III", "hp":490, "armor":290}
                    ],
                    "effect": effects['anchorWDV'],
                    "enableTorp": true
                },
                {
                    "text":"船渠棲姫",
                    "stat":[
                        {"text":"I", "hp":700, "armor":200},
                        {"text":"II", "hp":700, "armor":230},
                        {"text":"III", "hp":700, "armor":260},
                        {"text":"壊I", "hp":700, "armor":240},
                        {"text":"壊II", "hp":700, "armor":270},
                        {"text":"壊III", "hp":700, "armor":300}
                    ],
                    "effect": effects['dock'],
                    "enableTorp": true
                },
                {
                    "text":"砲台小鬼",
                    "stat":[
                        {"text":"I", "hp":130, "armor":100},
                        {"text":"II", "hp":130, "armor":105},
                        {"text":"III", "hp":130, "armor":110}
                    ],
                    "effect": effects['artillery']
                },
                {
                    "text":"対空小鬼",
                    "stat":[
                        {"text":"一般", "hp":88, "armor":60},
                        {"text":"elite", "hp":188, "armor":95}
                    ],
                    "effect": effects['artillery']
                },
                {
                    "text":"トーチカ小鬼",
                    "stat":[
                        {"text":"一般", "hp":180, "armor":100},
                        {"text":"elite", "hp":280, "armor":140}
                    ],
                    "effect": effects['artillery']
                },
                {
                    "text":"深海上陸小鬼",
                    "stat":[
                        {"text":"一般", "hp":220, "armor":77},
                        {"text":"elite", "hp":420, "armor":101},
                        {"text":"flagship", "hp":620, "armor":131}
                    ],
                    "effect": effects['artillery']
                },
                {
                    "text":"トーチカ要塞棲姫",
                    "stat":[
                        {"text":"I", "hp":1000, "armor":77},
                        {"text":"II", "hp":1600, "armor":177},
                        {"text":"壊I", "hp":1000, "armor":121},
                        {"text":"壊II", "hp":1600, "armor":211},
                    ],
                    "effect": effects['artillery']
                }
            ]
        }
    },
    computed: {
        'enemyInfo': function () {
            let enemy = {}
            enemy.stat = this.enemyList[this.target].stat[this.type]
            enemy.effect = this.enemyList[this.target].effect
            enemy.enableTorp = this.enemyList[this.target].enableTorp
            return enemy
        },
        'hp': function () {
            return this.enemyList[this.target].stat[this.type].hp
        },
        'armor': function () {
            return this.enemyList[this.target].stat[this.type].armor
        }
    },
    created: function () {
        this.$emit('update', this.enemyInfo)
    },
    methods: {
        target_change: function () {
            this.type = 0
        }
    },
    watch: {
        enemyInfo: function (){
            this.$emit('update', this.enemyInfo)
        }
    }
    
}
</script>

<style scoped>
.enemy-data {
    margin-bottom: 20px;
    padding-left: 15px;
    padding-right: 15px;
}

.enemy-data .col-xl-6 {
    padding-left: 0px;
    padding-right: 0px;
}
</style>